export default __webpack_public_path__ + "static/media/POPPINS-REGULAR.9171031e.TTF";